<template>
  <div class="flex-y-center gap-2">
    <div
      class="flex-y-center justify-center border border-gray-800 rounded-full relative overflow-hidden w-9 h-9 coin-shadow"
    >
      <template v-if="card?.coin?.image_svg || card?.base_currency?.image_svg">
        <div
          class="flex-y-center justify-center w-full h-full"
          v-html="card?.coin?.image_svg || card?.base_currency?.image_svg"
        />
      </template>
      <template v-else>
        <img
          v-if="card?.base_currency?.image_url || card?.coin?.image_url"
          :src="card?.base_currency?.image_url || card?.coin?.image_url"
          class="w-full h-full object-cover"
          alt="coin"
        />
        <img
          v-else
          src="/images/default-avatar.png"
          class="w-full h-full object-cover"
          alt="coin"
        />
      </template>
    </div>
    <div>
      <template v-if="withoutLink">
        <p
          class="text-sm leading-130 text-dark-300 font-semibold transition-300"
        >
          {{ pair }}
        </p>
      </template>
      <template v-else>
        <RouterLink
          :to="{
            name: `${locale}-BotsCoinSingle`,
            params: {
              coinId: card?.id,
              botId: routeBotId || card?.bot_id,
            },
          }"
          class="text-sm leading-130 text-dark-300 font-semibold hover:text-green transition-300"
        >
          {{ pair }}
        </RouterLink>
      </template>

      <!--      <p-->
      <!--        v-if="card?.status === 'active'"-->
      <!--        class="flex-y-center gap-1 text-xs !leading-normal font-medium text-green"-->
      <!--      >-->
      <!--        <i class="icon-tick-circle" />-->
      <!--        {{ $t("active") }}-->
      <!--      </p>-->
      <!--      <p-->
      <!--        v-else-->
      <!--        class="flex-y-center gap-1 text-xs !leading-normal font-medium text-red"-->
      <!--      >-->
      <!--        <i class="icon-forbidden" />-->
      <!--        {{ $t("inactive") }}-->
      <!--      </p>-->
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { computed } from "vue";

interface Props {
  card: any;
  pair: string;
  withoutLink?: boolean;
}

withDefaults(defineProps<Props>(), {
  withoutLink: false,
});

const route = useRoute();
const routeBotId = route.params.botId;
const locale = computed(() => route.path.split("/")[1]);
</script>

<style scoped>
.coin-shadow {
  box-shadow: 0 8px 36px 0 rgba(255, 255, 255, 0.12);
}
</style>
